// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3ttq5","topBottomGutter":"Layout_topBottomGutter__3kP1w"};